type ReadingPlanSessionTypesType = {
    api: 'api', // https://xxx.com/bstplan/plancode/#
    file: 'file', // session.json
    files: 'files', // session_XXXX.json
}
export const ReadingPlanSessionTypes: ReadingPlanSessionTypesType = {
    api: 'api',
    file: 'file',
    files: 'files',
}

export type ReadingPlanSessionTypesValues = typeof ReadingPlanSessionTypes[keyof typeof ReadingPlanSessionTypes]

export const AllReadingPlanSessionTypes: ReadingPlanSessionTypesValues[] = Array.from(Object.values(ReadingPlanSessionTypes));

export default ReadingPlanSessionTypes;